import { Button } from "./Button";

interface WelcomeVideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** YouTube video ID, served from the backend's WELCOME_VIDEO_ID setting. */
  videoId: string;
}

/**
 * One-time onboarding takeover shown on a new account's first login.
 *
 * Deliberately has no X, no Escape handler and no backdrop-click close — unlike
 * the app's other modals, the only way out is "Start Designing", so the video
 * is never dismissed by accident.
 */
export function WelcomeVideoModal({
  isOpen,
  onClose,
  videoId,
}: WelcomeVideoModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--bg-default-overlay)] backdrop-blur-md p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="welcome-video-title"
        className="w-full max-w-5xl max-h-[90vh] overflow-y-auto rounded-2xl bg-[var(--bg-modal)] p-6 shadow-xl"
      >
        <p className="text-xs font-medium uppercase tracking-[0.15em] text-[var(--text-secondary)]">
          Onboarding
        </p>
        <h2 id="welcome-video-title" className="text-heading-modal mt-1 mb-4">
          Welcome to IQ Design
        </h2>

        <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
          <iframe
            className="h-full w-full"
            src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
            title="Welcome to IQ Design"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture"
            allowFullScreen
          />
        </div>

        <div className="mt-6 flex justify-end">
          <Button variant="primary" onClick={onClose}>
            Start Designing
          </Button>
        </div>
      </div>
    </div>
  );
}
